import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import ReportsMenu from './reports-menu';
import ReportsProduction from './reports-production';
import ReportsEmployeePay from './reports-employee-pay';
import ReportsEmployees from './reports-employee';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }
}));

const Reports = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) {
        return <Loader />;
    }

    if (!state.permissions?.read_attr) {
        return <NotFound />;
    }

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Reports' />

            <Switch>
                <Route exact path={path}><ReportsMenu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/production`}><ReportsProduction permissions={state.permissions} /></Route>
                <Route exact path={`${path}/employeePay`}><ReportsEmployeePay permissions={state.permissions} /></Route>
                <Route exact path={`${path}/employee`}><ReportsEmployees permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default Reports;